import { InsightData } from 'schemas/action/InsightDataSchema'
import { TimeInterval, InsightViewOption } from 'enums'
import { Filter } from 'schemas/FilterSchema'
import { DayAndHourWidgetsType } from 'components/widget/DayAndHourWidgets/types'
import { timeRangeWeekAdjust } from 'components/widget/DayAndHourWidgets/share/utils'

export const getRange = (insights: Array<InsightData>) => {
  let minHour = 23
  let maxHour = 0
  const weekDays = new Set<string>()

  insights.forEach((insight) => {
    const hourNumber = Number(insight.name!.split('.')[1])
    const weekDay = insight.name!.split('.')[0]
    if (!Number.isNaN(hourNumber)) {
      minHour = Math.min(minHour, hourNumber)
      maxHour = Math.max(maxHour, hourNumber)
    }
    weekDays.add(weekDay)
  })

  const isInvalidHour = minHour > maxHour

  return {
    days: weekDays.has('All') ? [] : Array.from(weekDays),
    minHour: isInvalidHour ? 0 : minHour,
    maxHour: isInvalidHour ? 23 : maxHour
  }
}

export const getRangeConfig = (insights: Array<InsightData>) => {
  const { minHour, maxHour, days } = getRange(insights)

  const durationInfo = {
    ...(days.length && { days }),
    duration: maxHour! - minHour! + 1,
    startHour: minHour
  }
  return durationInfo
}

export const transformFilterPublishedDate = (
  filter: Filter,
  widgetSetting: DayAndHourWidgetsType
) => {
  const { timeInterval, viewOption } = widgetSetting
  const transformedFilter = { ...filter }
  if (
    viewOption === InsightViewOption.DAY_OF_WEEK ||
    viewOption === InsightViewOption.HOUR_OF_WEEK
  ) {
    const { start, end, isDirty } = timeRangeWeekAdjust({
      start: transformedFilter.publishedDate!.start!,
      end: transformedFilter.publishedDate!.end!,
      isCustom: timeInterval === TimeInterval.CUSTOM
    })
    if (isDirty) {
      transformedFilter.publishedDate!.start = start
      transformedFilter.publishedDate!.end = end
    }
  }
  return transformedFilter
}
